<script>
  import Media from "./Media.svelte";

  export let cachedMediaMetadatas;
  export let typeOfMedia;

  const isDisplayModeStandalone =
    window && window.matchMedia("(display-mode: standalone)").matches;
</script>

<style>
  div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  li {
    margin-bottom: 16px;
  }
</style>

<!--
Copyright 2019 Google, Inc.

Licensed under the [Apache License, Version 2.0](LICENSE) (the "License");
you may not use this file except in compliance with the License. You may
obtain a copy of the License at

  http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

